import script from "./JournalInPlace.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalInPlace.vue?vue&type=script&setup=true&lang=js"

import "./JournalInPlace.vue?vue&type=style&index=0&id=8c56fd72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c56fd72"]])

export default __exports__